import { useEffect, useState } from "react";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function AddCustomer() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dob: "",
    country: "",
    street: "",
    city: "",
    borough: "",
    state: "NY",
    zip: "",
    payment: "",
    paymentFrequency: "",
    password: "",
    confirmPassword: "",
    rc_id: sessionStorage.getItem("rc_id") || "",

  });

  const [zipCheckResult, setZipCheckResult] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [message, setMessage] = useState(null);
  const [centers, setCenters] = useState([]);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const res = await axios.get("/auth/redemption-centers");
        setCenters(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCenters();
  }, []);


  const handleChange = (e) => {
    const { id, value } = e.target;

    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [id]: value,
      };

      // Validate passwords on change
      if (
        (id === "password" || id === "confirmPassword") &&
        updatedForm.confirmPassword !== ""
      ) {
        if (updatedForm.password !== updatedForm.confirmPassword) {
          setPasswordError("Passwords do not match.");
        } else {
          setPasswordError("");
        }
      }

      return updatedForm;
    });

    if (id === "zip" || id === "borough") {
      setZipCheckResult(null); // Reset ZIP check result if changed
    }
  };

  const handleZipCheck = async () => {
    try {
      const res = await axios.post("/auth/check-service-area", {
        state: form.state,
        borough: form.borough,
        zipcode: form.zip,
      });
      setZipCheckResult({ available: true, message: res.data.message });
      toast.success(res.data.message);
    } catch (err) {
      const msg = err.response?.data?.message || "Error checking ZIP availability.";
      setZipCheckResult({ available: false, message: msg });
      toast.error(msg);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setSubmitting(true);

    try {
      const payload = {
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        phone: form.phone,
        dob: form.dob,
        country: form.country,
        address: form.street,
        city: form.city,
        state: form.state,
        zip: form.zip,
        borough: form.borough,
        paymentMethod: form.payment,
        paymentFrequency: form.paymentFrequency,
        password: form.password,
        userType: "customer", // ✅ important for your insertController.js logic
        rc_id: form.rc_id
      };

      const res = await axios.post(
        "/auth/users/register", // use your actual backend route for registerUser
        payload
      );

      toast.success(res.data.message);

      // Redirect to customer list after adding
      setTimeout(() => navigate("/redem-customerlist"), 1500);
    } catch (err) {
      toast.error(err.response?.data?.message || "Error adding customer");
    } finally {
      setSubmitting(false);
    }
  };


  return (
    <section className="px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white max-w-4xl mx-auto p-6 sm:p-8 rounded-2xl shadow-lg">
        <h1 className="text-3xl font-bold text-center text-green-700 mb-8">
          Add Customer
        </h1>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="grid gap-4 sm:grid-cols-2">
            <Input label="First Name *" id="firstName" value={form.firstName} onChange={handleChange} required />
            <Input label="Last Name *" id="lastName" value={form.lastName} onChange={handleChange} required />
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <Input label="Email *" id="email" type="email" value={form.email} onChange={handleChange} required />
            <Input label="Phone Number *" id="phone" value={form.phone} onChange={handleChange} required />
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <Input label="Date of Birth" id="dob" type="date" value={form.dob} onChange={handleChange} required />
            <Select
              label="Country"
              id="country"
              value={form.country}
              onChange={handleChange}
              options={["India", "USA", "UK"]}
            />
          </div>

          <Input label="Street Address" id="street" value={form.street} onChange={handleChange} />

          <div className="grid gap-4 sm:grid-cols-2">
            <Input label="City" id="city" value={form.city} onChange={handleChange} required />
            <Select
              label="Borough"
              id="borough"
              value={form.borough}
              onChange={handleChange}
              options={["Bronx", "Queens", "Manhattan", "Brooklyn", "Staten Island"]}
            />
          </div>
          <div>




          </div>
          <div className="grid gap-4 sm:grid-cols-3">
            <Input label="State" id="state" value="NY" readOnly />
            <Input label="ZIP" id="zip" value={form.zip} onChange={handleChange} />
            <div className="flex items-end">
              <button
                type="button"
                onClick={handleZipCheck}
                className="w-full px-4 py-2 bg-[#54BE73] text-white rounded-md hover:bg-green-700"
              >
                Check Availability
              </button>
            </div>
          </div>

          {zipCheckResult && (
            <div className={`text-sm ${zipCheckResult.available ? "text-green-600" : "text-red-600"}`}>
              {zipCheckResult.message}
            </div>
          )}
          <div className="grid gap-4 sm:grid-cols-2">
            <Select
              label="Payment Method"
              id="payment"
              value={form.payment}
              onChange={handleChange}
              options={["Cash", "Ev-voucher", "Fuel-Voucher", "Stock-credit", "Check by Mail", "ACH", "PayPal"]}
            />
            <div>
              <label className="block font-medium mb-1">Payment Frequency</label>
              <div className="flex items-center gap-6">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="paymentFrequency"
                    id="paymentFrequency"
                    value="Weekly"
                    checked={form.paymentFrequency === 'Weekly'}
                    onChange={handleChange}
                    className="form-radio text-green-600"
                    required
                  />
                  <span className="ml-2">Weekly</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    id="paymentFrequency"
                    name="paymentFrequency"
                    value="Daily"
                    checked={form.paymentFrequency === 'Daily'}
                    onChange={handleChange}
                    className="form-radio text-green-600"
                  />
                  <span className="ml-2">Daily</span>
                </label>
              </div>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <Input
              label="Password *"
              id="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
            />
            <Input
              label="Confirm Password *"
              id="confirmPassword"
              type="password"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
            {passwordError && (
              <p className="text-red-500 text-sm mt-1">{passwordError}</p>
            )}
          </div>

          <div className="flex justify-end gap-4 pt-2">
            <button
              type="button"
              onClick={() => navigate("/redem-customerlist")}
              className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="px-6 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
            >
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </section>
  );
}

// Reusable components
const Input = ({ label, id, type = "text", value, onChange, readOnly, required }) => (
  <div>
    <label htmlFor={id} className="block mb-1 font-medium">
      {label}
    </label>
    <input
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      required={required}
      readOnly={readOnly}
      className={`w-full rounded-lg p-3 ring-1 ${readOnly ? "bg-gray-100" : "bg-lime-50"} ring-gray-300`}
    />
  </div>
);

const Select = ({ label, id, value, onChange, options }) => (
  <div>
    <label htmlFor={id} className="block mb-1 font-medium">
      {label}
    </label>
    <select
      id={id}
      value={value}
      onChange={onChange}
      className="w-full rounded-lg p-3 ring-1 ring-gray-300 bg-lime-50"
    >
      <option value="">Select {label}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  </div>
);
